export class ImportDlsgCertificateRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "certificateBody",
            "baseName": "certificateBody",
            "type": "string",
            "format": ""
        },
        {
            "name": "certificatePrivateKey",
            "baseName": "certificatePrivateKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "certificateChain",
            "baseName": "certificateChain",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ImportDlsgCertificateRequest.attributeTypeMap;
    }
    constructor() {
    }
}
